module.exports = __webpack_public_path__ + "static/media/CaliforniasRedwoods.85a5117a.jpg";